module.exports = __webpack_public_path__ + "img/bg-5.c50a30ec.png";